import React, { useEffect, useState } from 'react';
import { Card, CardBody, Table } from 'reactstrap';
import { Button } from '../../components';
import { InvoicingDetailDto } from '../../types';
import { NavLink } from 'react-router-dom';
import { invoiceService } from '../../services/InvoiceService';
import { toast } from 'react-toastify';

const FailedInvoices = () => {
    const [failedList, setFailedList] = useState<InvoicingDetailDto[]>();
    const [reload, setReload] = useState(false);

    useEffect(() => {
        invoiceService
            .getFailedInvoices()
            .then((response) => {
                setFailedList(response);
                setReload(false);
            })
            .catch(() => toast.error('Failed to get invoices'));
    }, [reload]);

    const dismissActivity = (invoice: InvoicingDetailDto) => {
        const toastId = toast.info('Dismissing Activity...');

        invoiceService
            .saveInvoice(invoice.id)
            .then(() => {
                toast.update(toastId, {
                    type: 'success',
                    render: 'Activity dismissed',
                    autoClose: 5000,
                    closeOnClick: true,
                    draggable: true,
                });
                setReload(true);
            })
            .catch((e) => {
                if (e.error) {
                    toast.update(toastId, {
                        type: 'error',
                        render: e.error,
                        autoClose: 5000,
                        closeOnClick: true,
                        draggable: true,
                    });
                } else {
                    toast.update(toastId, {
                        type: 'error',
                        render: 'Error dismissing activity',
                        autoClose: 5000,
                        closeOnClick: true,
                        draggable: true,
                    });
                }
            });
    };

    return (
        <Card>
            <CardBody>
                <h3>Failed Invoices</h3>
            </CardBody>
            <Table>
                <thead>
                    <tr>
                        <th>Invoice Number</th>
                        <th>Institution</th>
                        <th>Errors</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {failedList &&
                        failedList.map((invoice) => (
                            <tr key={invoice.id}>
                                <td>{invoice.invoiceNumber}</td>
                                <td>
                                    <NavLink to={`/institution/${invoice.institutionId}`}>
                                        {invoice.institutionTitle}
                                    </NavLink>
                                </td>
                                <td>
                                    <ul>
                                        {invoice.invoiceActivities.map((act) => (
                                            <li key={act.id}>{act.message}</li>
                                        ))}
                                    </ul>
                                </td>
                                <td>
                                    <Button color="link" onClick={() => dismissActivity(invoice)}>
                                        Dismiss &amp; Regenerate
                                    </Button>
                                </td>
                            </tr>
                        ))}
                    {(!failedList || failedList.length === 0) && (
                        <tr>
                            <td colSpan={4}>No Failed Invoices</td>
                        </tr>
                    )}
                </tbody>
            </Table>
        </Card>
    );
};

export default FailedInvoices;
